import mailgun from 'mailgun.js';
import formData from 'form-data';

const apiKey = process.env.REACT_APP_BODYMIRACLE_MAILGUN_API_KEY;
const domain = 'mailer.bodymiracle.com';

if (!apiKey) {
  throw new Error('Mailgun API key is missing. Please set REACT_APP_BODYMIRACLE_MAILGUN_API_KEY in your environment.');
}

const mailgunClient = new mailgun(formData).client({
  username: 'api',
  key: apiKey,
});

export const mailgunService = {
  sendEmail: async (
    to: string,
    subject: string,
    text: string,
    html?: string,
    from: string = 'no-reply@mailer.bodymiracle.com'
  ): Promise<any> => {
    try {
      const response = await mailgunClient.messages.create(domain, {
        from,
        to,
        subject,
        text,
        html,
      });
      console.log('Email sent successfully:', response);
      return response;
    } catch (e:any) {
      console.error('Failed to send email:', e);
      throw new Error(e);
    }
  },
};